import * as React from 'react';
import { __ } from '../../../helpers/TranslationService';
import styled from '@emotion/styled';
import { Button } from '../../../components/Button/Button';
import { config } from '../../../config';
import { BreakpointsEnum } from '../../../helpers/breakpoints';
import { SearchIcon } from '../../../components/Icons/SearchIcon';

const EmptyFavoritesWrapper = styled.div`
    margin: 0 auto;
    text-align: center;
    max-width: 620px;
    padding: 48px 16px 60px 16px;
    @media (min-width: ${BreakpointsEnum.md}) {
        padding: 80px 16px 120px 16px;
    }
`;

const EmptyFavoritesTitle = styled.h2`
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-top: 0;
    @media (min-width: ${BreakpointsEnum.md}) {
        font-size: 28px;
        line-height: 38px;
    }
`;

const EmptyFavoritesDescription = styled.p`
    font-size: 16px;
    line-height: 24px;
`;

const EmptyFavoritesImage = styled.div`
    margin: 36px 0;
`;
interface IProps {
    deviceType: string;
    doNewSearchViaUrl: Function;
    clearFilterParams: Function;
}

export const NoFavorites = (props: IProps) => {
    const newSearch = () => {
        props.clearFilterParams(false);
        props.doNewSearchViaUrl();
    };

    return (
        <EmptyFavoritesWrapper>
            <EmptyFavoritesTitle>
                {__('noItemsInFavorites.title', 'dreamlines')}
            </EmptyFavoritesTitle>
            <EmptyFavoritesDescription>
                {__('noItemsInFavorites.description', 'dreamlines')}
            </EmptyFavoritesDescription>
            <EmptyFavoritesImage>
                {props.deviceType === 'desktop' ? (
                    <img
                        src={`${config.images}/common/favorites_illustration_horizontal.png`}
                        width={617}
                        height={270}
                    />
                ) : (
                    <img
                        src={`${config.images}/common/favorites_illustration.png`}
                        width={256}
                        height={270}
                    />
                )}
            </EmptyFavoritesImage>
            <Button
                onClick={newSearch}
                size="large"
                type="button"
                color="primary"
                fullWidth={props.deviceType !== 'desktop'}
                startIcon={<SearchIcon />}
            >
                {__('Search cruise', 'dreamlines')}
            </Button>
        </EmptyFavoritesWrapper>
    );
};
